module.exports = __webpack_public_path__ + "img/login_3.33db7843.svg";